<template >
  <div class="background">
    <v-container fluid>
      <v-row class="full-vh-height" align="center" justify="center">
        <v-card rounded class="content-card" style="position:relative">

          <v-container fluid class="full-height" v-if="!premessageScreen">
            <v-row class="full-height" justify="center" >
              <v-col cols="8">
                <v-row align="center" justify="center">
                  <p class="form-title">{{ title }}</p>
                </v-row>
                <v-row align="center" justify="center">
                  <p class="form-text">{{ text }}</p>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col cols="6">
                    <v-row align="center" justify="end">
                      <v-img src="/img/reader/answeroption-images.png" class="option-img" />
                    </v-row>
                    <v-row align="center" justify="end">
                      <v-btn
                        rounded
                        color="#F2865F"
                        dark
                        class="mr-7 mt-7 font-btn"
                        width="145px"
                        height="50px"
                        :loading="loadingButtonWords"
                        :disabled="loadingButtonImages"
                        @click="loadingButtonWords=true; getChallengeOptionsAndContinue(3)"
                      >
                        {{ $t('challenge.beginning_initial_challenge_question_option_images') }}
                      </v-btn>
                    </v-row>
                  </v-col>
                  <v-col cols="6">
                    <v-row align="center" justify="start">
                      <v-img src="/img/reader/answeroption-words.png" class="option-img" />
                    </v-row>
                    <v-row align="center" justify="start">
                      <v-btn
                        rounded
                        color="#F2865F"
                        dark
                        class="ml-7 mt-7 font-btn"
                        width="145px"
                        height="50px"
                        :loading="loadingButtonImages"
                        :disabled="loadingButtonWords"
                        @click="loadingButtonImages=true; getChallengeOptionsAndContinue(1)"
                      >
                        {{ $t('challenge.beginning_initial_challenge_question_option_words') }}
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>

          <v-img
          :src="require('../../../assets/img/bees/bee004.svg')"
          elevation="6"
          contain
          class="bee-one"
          v-if="premessageScreen"
          ></v-img>
          <v-img
          :src="require('../../../assets/img/bees/bee005.svg')"
          elevation="6"
          contain
          class="bee-two"
          v-if="premessageScreen"
          ></v-img>
          <v-container fluid class=" full-height" v-if="premessageScreen">
              <v-row align="center" justify="center" >
                  <v-col cols="12" style="max-width: 500px">
                      <v-row align="center" justify="start" style="margin-top: 98px">
                          <p class="premessage-font-title">{{ title }}</p>
                      </v-row>
                      <v-row align="center" justify="start" class="text-left" style="margin-top: 45px">
                          <p class="premessage-font-text">
                          {{ $t('challenge.beginning_initial_challenge_premessage_text') }}
                          </p>
                      </v-row>
                      <v-row align="center" justify="center" style="margin-top: 45px">
                          <v-btn
                          rounded
                          color="#F2865F"
                          dark
                          class="mr-10 mt-10 font-btn"
                          style="font-size: 15px"
                          width="300px"
                          height="50px"
                          @click="changeScreen()"
                          >
                          {{ $t('challenge.initial_text_button') }}
                          </v-btn>
                      </v-row>
                  </v-col>
              </v-row>
          </v-container>

        </v-card>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      modalActive: false,
      premessageScreen: true,
      loadingButtonWords: false,
      loadingButtonImages: false
    }
  },
  props: {
    title: { type: String, required: true },
    text: { type: String, required: true },
    points: { type: [String, Number], required: true },
    beecoins: { type: [String, Number], required: true },
    getChallenge: { type: Function, required: true }
  },
  computed: {
    buttonSize() {
      return {
        width:
          this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md
            ? '350px'
            : '18vw',
        height:
          this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md
            ? '70px'
            : '3vw',
      }
    },
  },
  methods: {
    ...mapActions('challenge', ['setChallengeStage', 'setReadingTime', 'setReReadingTime']),
    changeScreen() {
        setTimeout(() => { this.premessageScreen = false }, 300);
    },
    async getChallengeOptionsAndContinue( optionTemplate ) {
        await this.getChallenge( optionTemplate );
        this.loadingButtonWords = false;
        this.loadingButtonImages = false;
    }
  },
}
</script>
<style scoped>
.background {
  background-image: url('/img/wallpaper/maze.png');
  background-size: cover;
  width: auto;
  height: auto;
}

.content-card {
  border-radius: 1vw !important;
  background: linear-gradient(146.1deg, #6d5bb0 0%, #b5a1eb 100%);
  border: 20px solid #5d5286;
  width: 600px;
  height: 600px;
}

.full-height {
  height: 100%;
}

.full-vh-height {
  height: 100vh;
}

.form-title {
  color: #ffffff;
  font-weight: 700;
  font-size: 34px;
  margin-top: 60px;
}

.form-text {
  color: #ffffff;
  font-size: 18px;
  margin-top: 10px;
}

.option-img {
  max-width: 170px;
  margin-top: 30px;
}

.button-text {
  width: 145px;
  height: 50px;
}

.font-btn {
  text-transform: initial;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 26px;
}

.corner-number {
  position: absolute;
  left: -40px;
  top: -30px;
  width: 7vw;
  height: 8vw;
}

.corner-premessage-square {
  position: absolute;
  background-color: white;
  left: 0px;
  top: 0px;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.bee-one {
  position: absolute;
  right: -40px;
  top: -50px;
  width: 130px;
  height: 130px;
}

.bee-two {
  position: absolute;
  left: 380px;
  bottom: -45px;
  width: 130px;
  height: 130px;
}

.premessage-font-title {
  font-style: normal;
  font-weight: 700;
  font-size: 37px;
  color: #FFFFFF;
}

.premessage-font-text {
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  color: #FFFFFF;
}

@media (min-width: 1264px) {
  .content-card {
    width: 700px;
    height: 550px;
  }
}
</style>